import React, { FC } from "react";
import { Box, Typography } from "@mui/material";
import { useIntl } from "react-intl";

export interface IStationTrainTciProps {
  color: string;
  value: number | null | undefined;
}

export const StationTrainTci: FC<IStationTrainTciProps> = ({ color, value }) => {
  const { formatMessage, formatNumber } = useIntl();

  const formattedValue =
    typeof value === "number" && !Number.isNaN(value) ? formatNumber(Math.round(value * 100) / 100) : "—";

  const label = formatMessage({ id: "pages.scheme.stationTile.tci" });

  return (
    <Box
      title={`${label}: ${formattedValue}`}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: 24,
        px: 0.375,
        border: "1px solid #DADDE5",
        borderRadius: "3px",
        boxSizing: "border-box",
        backgroundColor: "#FFFFFF",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.375,
          minWidth: 0,
          maxWidth: "100%",
        }}
      >
        <Box
          sx={{
            width: 9,
            height: 9,
            borderRadius: "50%",
            backgroundColor: color,
            border: color.toLowerCase() === "#ffffff" ? "1px solid #B8C0D0" : "none",
            boxSizing: "border-box",
            flexShrink: 0,
          }}
        />
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            lineHeight: "15px",
            fontWeight: 700,
            color: "#363846",
            flexShrink: 0,
          }}
        >
          {label}:
        </Typography>
        <Typography
          component="span"
          sx={{
            fontSize: 12,
            lineHeight: "15px",
            fontWeight: 400,
            color: "#363846",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {formattedValue}
        </Typography>
      </Box>
    </Box>
  );
};
